import {
  CreditBalanceDto,
  BookEventRequestDto,
} from './dto/requests/book-event.request.dto';
import AppHttpClient from '../api-manager/api/http-client';
import HttpPathsEnum from '../api-manager/api/http-paths.enum';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';
import { BookEventResponseDto } from './dto/responses/book-event.response.dto';
import { EventFiltersRequestDto } from './dto/requests/event-filters.request.dto';
import { GetCategoryResponseDto } from './dto/responses/get-category.response.dto';
import { GetEventsByIdResponseDto } from './dto/responses/get-events-by-id.response.dto';
import { GetSubCategoryResponseDto } from './dto/responses/get-sub-category.response.dto';
import { GetEventsByFilterResponseDto } from './dto/responses/get-events-by-filter.response.dto';
import { CategoryEnum } from '../../store/events/eventTypes';

const EVENTS_PATH = HttpPathsEnum.EVENTS;
const COMPANY_PATH = HttpPathsEnum.COMPANY;

class EventApi {
  public async bookEvent(
    createBookEventDto: BookEventRequestDto,
    creditBalanceDto: CreditBalanceDto,
    dontCreateOrder = false
  ) {
    const request: HttpRequest = {
      url: `${EVENTS_PATH}/event/book-event`,
      method: RequestType.POST,
      data: {
        createBookEventDto,
        creditBalanceDto,
        dont_create_order: dontCreateOrder,
      },
    };

    return await AppHttpClient.exec<any, any>(request, BookEventResponseDto);
  }

  public async startOrderCancellationProcess(orderId: number) {
    const request: HttpRequest = {
      url: `${COMPANY_PATH}/admin-order/start-cancellation-process/${orderId}`,
      method: RequestType.PUT,
    };

    return await AppHttpClient.exec<any, any>(request, {});
  }

  public async getFilteredEvents(filters: EventFiltersRequestDto) {
    const request: HttpRequest = {
      url: `${EVENTS_PATH}/event/all/filters`,
      method: RequestType.GET,
      params: filters,
    };

    return await AppHttpClient.exec<any, GetEventsByFilterResponseDto>(
      request,
      GetEventsByFilterResponseDto
    );
  }

  public async getEventById(id: number) {
    const request: HttpRequest = {
      url: `${EVENTS_PATH}/event/${id}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetEventsByIdResponseDto>(
      request,
      GetEventsByIdResponseDto
    );
  }

  public async getValidEventById(id: number) {
    const request: HttpRequest = {
      url: `${EVENTS_PATH}/event/find-valid-event-by-id/${id}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetEventsByIdResponseDto>(
      request,
      GetEventsByIdResponseDto
    );
  }

  public async getEventCategories() {
    const request: HttpRequest = {
      url: `${EVENTS_PATH}/category/all`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetCategoryResponseDto[]>(
      request,
      GetCategoryResponseDto
    );
  }

  public async getEventSubCategoriesByCategoryId(name: CategoryEnum) {
    const request: HttpRequest = {
      url: `${EVENTS_PATH}/category/sub-categories-by-name?name=${name}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetSubCategoryResponseDto[]>(
      request,
      GetSubCategoryResponseDto
    );
  }

  public async cancelBooking(eventId: number) {
    const request: HttpRequest = {
      url: `${EVENTS_PATH}/event/cancel-booking/${eventId}`,
      method: RequestType.POST,
    };

    return await AppHttpClient.exec<any, boolean>(request, Boolean);
  }
}

export default new EventApi();
